// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import { Card } from "../../../../Components/ui/card";
// // import { Label } from "../../../../Components/ui/label";
// // import { Switch } from "../../../../Components/ui/switch";
// // import {
// //   Select,
// //   SelectTrigger,
// //   SelectValue,
// //   SelectContent,
// //   SelectItem,
// // } from "../../../../Components/ui/select";
// // import {
// //   Accordion,
// //   AccordionItem,
// //   AccordionTrigger,
// //   AccordionContent,
// // } from "../../../../Components/ui/accordion";
// // import { useCampaignContext } from "../CampaignContext";
// // import RoamingDaysSection from "./RoamingDaysSection";
// // import { useSelector } from "react-redux";
// // import { RootState } from "@/src/State/store";
// // import { getChannelCounts } from "../utils/getChannelCounts";

// // interface Campaign {
// //   campaign_id: number;
// //   campaign_name: string;
// //   advertiser_workspace_id: number;
// //   workspace_name: string;
// //   status: string;
// //   start_date: string;
// //   end_date: string;
// //   total_traveller_count: string;
// //   delivered_count: number;
// // }

// // const getStatusBadgeStyle = (status: string): React.CSSProperties => {
// //   switch (status.toLowerCase()) {
// //     case "active":
// //       return { backgroundColor: "#EAF3DE", color: "#3B6D11" };
// //     case "paused":
// //       return { backgroundColor: "#FAEEDA", color: "#854F0B" };
// //     case "completed":
// //       return { backgroundColor: "#F1EFE8", color: "#444441" };
// //     default:
// //       return { backgroundColor: "#F1EFE8", color: "#444441" };
// //   }
// // };

// // const getChannelBadges = (totalTravellerCount: string): string[] => {
// //   try {
// //     const parsed = JSON.parse(totalTravellerCount);
// //     const badges: string[] = [];
// //     if (parsed.sms_count?.length > 0) badges.push("SMS");
// //     if (parsed.whatsapp_count?.length > 0) badges.push("WhatsApp");
// //     return badges;
// //   } catch {
// //     return [];
// //   }
// // };

// // const formatDateRange = (startDate: string, endDate: string): string => {
// //   const format = (d: string) =>
// //     new Date(d).toLocaleDateString("en-GB", {
// //       day: "numeric",
// //       month: "short",
// //       year: "numeric",
// //     });
// //   return `${format(startDate)} – ${format(endDate)}`;
// // };

// // const badgeBase: React.CSSProperties = {
// //   fontSize: "11px",
// //   padding: "2px 8px",
// //   borderRadius: "99px",
// //   fontWeight: 500,
// //   display: "inline-block",
// //   whiteSpace: "nowrap",
// // };

// // const channelBadgeStyle: React.CSSProperties = {
// //   ...badgeBase,
// //   backgroundColor: "#EEEDFE",
// //   color: "#3C3489",
// // };

// // const AdvancedSettingsCard: React.FC = () => {
// //   const {
// //     allocationType,
// //     setAllocationType,
// //     isDuplicatePrevented,
// //     setIsDuplicatePrevented,
// //     isPremiumOnly,
// //     setIsPremiumOnly,
// //     audienceType,
// //     setAudienceType,
// //     selectedCampaign,
// //     setSelectedCampaign,
// //     isViewMode,
// //     selectedChannels,
// //     countries,
// //     whatsappData,
// //     smsData,
// //     fromCountryISOs,
// //     selectedToCountryISO,
// //     isSubmitAttempted,
// //   } = useCampaignContext();

// //   const accountId = useSelector((state: RootState) => state.authentication.account_id);
// //   const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
// //   const selectedFromCountryISOs = useSelector(
// //     (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
// //   );

// //   const [availableCampaigns, setAvailableCampaigns] = useState<Campaign[]>([]);
// //   const [dropdownOpen, setDropdownOpen] = useState(false);
// //   const dropdownRef = useRef<HTMLDivElement>(null);

// //   // Stable string key — only changes when actual traveller count values change
// //   const travellerCountKey = JSON.stringify(
// //     getChannelCounts(whatsappData, smsData, selectedToCountryISO, fromCountryISOs)
// //   );

// //   // Close dropdown on outside click
// //   useEffect(() => {
// //     const handleClickOutside = (e: MouseEvent) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
// //         setDropdownOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   const fromCountryNames = selectedFromCountryISOs
// //     .map((iso: string) => {
// //       const match = countries.find(
// //         (c) => c.country_iso.toLowerCase() === iso.toLowerCase()
// //       );
// //       return match ? match.country_name : iso.toUpperCase();
// //     })
// //     .join(", ");

// //   const channelLabel = selectedChannels.join(" & ");

// //   const GetCampaignsByAccountId = async () => {
// //     try {
// //       const travellerCount = getChannelCounts(
// //         whatsappData,
// //         smsData,
// //         selectedToCountryISO,
// //         fromCountryISOs
// //       );

// //       const res = await axios.post(`${apiUrlAdvAcc}/GetCampaignNamesByAccountId`, {
// //         userAccountId: accountId,
// //         channels: selectedChannels.join(","),
// //         fromCountryISOs: selectedFromCountryISOs.join(","),
// //         travellerCount,
// //       });

// //       if (res.data.status === "Success" && Array.isArray(res.data.campaignList)) {
// //         setAvailableCampaigns(res.data.campaignList);
// //       } else {
// //         setAvailableCampaigns([]);
// //       }
// //     } catch (err) {
// //       setAvailableCampaigns([]);
// //     }
// //   };

// //   useEffect(() => {
// //     if (
// //       audienceType === "Reuse Audience" &&
// //       selectedChannels.length > 0 &&
// //       selectedFromCountryISOs.length > 0
// //     ) {
// //       GetCampaignsByAccountId();
// //     }
// //   }, [audienceType, selectedChannels, selectedFromCountryISOs, travellerCountKey]);

// //   const groupedCampaigns = availableCampaigns.reduce((acc, campaign) => {
// //     if (!acc[campaign.workspace_name]) {
// //       acc[campaign.workspace_name] = [];
// //     }
// //     acc[campaign.workspace_name].push(campaign);
// //     return acc;
// //   }, {} as Record<string, Campaign[]>);

// //   const selectedCampaignName = availableCampaigns.find(
// //     (c) => String(c.campaign_id) === selectedCampaign
// //   )?.campaign_name;

// //   const getReuseAudienceNote = () => {
// //     if (selectedChannels.length === 0 || selectedFromCountryISOs.length === 0) {
// //       return "Select channel and from-country to see matching campaigns";
// //     }
// //     if (availableCampaigns.length > 0) {
// //       return `Showing ${channelLabel} campaigns from ${fromCountryNames} only. Channel and from-country must match.`;
// //     }
// //     return `No ${channelLabel} campaigns from ${fromCountryNames} found. Run a ${channelLabel} campaign from this country first to enable audience reuse.`;
// //   };

// //   // Red border + error note when submit attempted, campaigns available but none selected
// //   const showAudienceError =
// //     isSubmitAttempted &&
// //     audienceType === "Reuse Audience" &&
// //     availableCampaigns.length > 0 &&
// //     !selectedCampaign;

// //   // Turns descriptive note red when submit attempted but no campaigns found
// //   const showNoAudienceAvailableError =
// //     isSubmitAttempted &&
// //     audienceType === "Reuse Audience" &&
// //     availableCampaigns.length === 0 &&
// //     selectedChannels.length > 0 &&
// //     selectedFromCountryISOs.length > 0;

// //   return (
// //     <Card className="w-[600px] mt-4 mb-20 p-4 shadow-sm">
// //       <div className="text-left">
// //         <Accordion type="single" collapsible className="w-full">
// //           <AccordionItem value="advanced-settings" className="border-b-0">
// //             <AccordionTrigger className="text-base font-bold text-[#020617]">
// //               Advanced Settings
// //             </AccordionTrigger>
// //             <AccordionContent>
// //               {/* Premium Contacts Only */}
// //               <div className="flex items-center space-x-2 mt-1">
// //                 <Switch
// //                   id="premiumContactsOnly"
// //                   checked={isPremiumOnly}
// //                   onCheckedChange={setIsPremiumOnly}
// //                   disabled={isViewMode}
// //                 />
// //                 <Label
// //                   htmlFor="premiumContactsOnly"
// //                   className="font-medium text-[#020617]"
// //                   style={{ fontSize: "14px" }}
// //                 >
// //                   Premium Contacts Only
// //                 </Label>
// //               </div>

// //               {/* Prevent Duplicate Messages */}
// //               <div className="flex items-center space-x-2 mt-4">
// //                 <Switch
// //                   id="preventDuplicateMessages"
// //                   checked={isDuplicatePrevented}
// //                   onCheckedChange={setIsDuplicatePrevented}
// //                   disabled={isViewMode}
// //                 />
// //                 <Label
// //                   htmlFor="preventDuplicateMessages"
// //                   className="font-medium text-[#020617]"
// //                   style={{ fontSize: "14px" }}
// //                 >
// //                   Prevent duplicate Messages
// //                 </Label>
// //               </div>

// //               {/* Allocation Type */}
// //               <div className="mt-4">
// //                 <Label
// //                   htmlFor="allocationType"
// //                   className="font-medium text-[#020617]"
// //                   style={{ fontSize: "14px" }}
// //                 >
// //                   Allocation Type
// //                 </Label>
// //                 <Select
// //                   value={allocationType}
// //                   onValueChange={setAllocationType}
// //                   disabled={isViewMode}
// //                 >
// //                   <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
// //                     <SelectValue placeholder="Select Allocation Type" />
// //                   </SelectTrigger>
// //                   <SelectContent>
// //                     <SelectItem value="Daily Allocation">Daily Allocation</SelectItem>
// //                     <SelectItem value="Lifetime Allocation">Lifetime Allocation</SelectItem>
// //                   </SelectContent>
// //                 </Select>
// //                 <p className="text-xs text-[#64748B] mt-1">
// //                   {allocationType === "Daily Allocation"
// //                     ? "Distribute messages evenly across campaign duration"
// //                     : "Send messages as soon as eligible travellers are available"}
// //                 </p>
// //               </div>

// //               {/* Audience Type + Campaign Selection */}
// //               <div className="mt-4">
// //                 {/* Row: Audience Type + Campaign Trigger */}
// //                 <div className="flex gap-4 items-end">
// //                   {/* Audience Type Dropdown */}
// //                   <div className="flex-1">
// //                     <Label
// //                       htmlFor="audienceType"
// //                       className="font-medium text-[#020617]"
// //                       style={{ fontSize: "14px" }}
// //                     >
// //                       Audience Type
// //                     </Label>
// //                     <Select
// //                       value={audienceType}
// //                       onValueChange={(value) => {
// //                         setAudienceType(value);
// //                         if (value !== "Reuse Audience") {
// //                           setSelectedCampaign("");
// //                           setDropdownOpen(false);
// //                         }
// //                       }}
// //                       disabled={isViewMode}
// //                       defaultValue="None"
// //                     >
// //                       <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
// //                         <SelectValue placeholder="Select Audience Type" />
// //                       </SelectTrigger>
// //                       <SelectContent>
// //                         <SelectItem value="None">None</SelectItem>
// //                         <SelectItem value="Reuse Audience">Reuse Audience</SelectItem>
// //                         <SelectItem value="New Audience">New Audience</SelectItem>
// //                       </SelectContent>
// //                     </Select>

// //                     {audienceType !== "Reuse Audience" && (
// //                       <p className="text-xs text-[#64748B] mt-1">
// //                         {audienceType === "None" || audienceType === ""
// //                           ? "Use standard audience selection rules"
// //                           : audienceType === "New Audience"
// //                             ? "Target only Fresh Audience"
// //                             : "Select how to target your audience"}
// //                       </p>
// //                     )}
// //                   </div>

// //                   {/* Campaign Trigger — shows only when Reuse Audience */}
// //                   {audienceType === "Reuse Audience" && availableCampaigns.length > 0 && (
// //                     <div className="flex-1">
// //                       <div
// //                         onClick={() => !isViewMode && setDropdownOpen((prev) => !prev)}
// //                         style={{
// //                           border: showAudienceError
// //                             ? "1.5px solid #EF4444"
// //                             : dropdownOpen
// //                               ? "1.5px solid #378ADD"
// //                               : "1px solid #E2E8F0",
// //                           borderRadius: "6px",
// //                           padding: "8px 12px",
// //                           fontSize: "13px",
// //                           color: selectedCampaignName ? "#020617" : "#64748B",
// //                           display: "flex",
// //                           justifyContent: "space-between",
// //                           alignItems: "center",
// //                           cursor: isViewMode ? "default" : "pointer",
// //                           backgroundColor: "white",
// //                           userSelect: "none",
// //                         }}
// //                       >
// //                         <span>{selectedCampaignName ?? "Select a campaign"}</span>
// //                         <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
// //                           <path
// //                             d={dropdownOpen ? "M3 7.5L6 4.5L9 7.5" : "M3 4.5L6 7.5L9 4.5"}
// //                             stroke="#64748B"
// //                             strokeWidth="1.2"
// //                             strokeLinecap="round"
// //                           />
// //                         </svg>
// //                       </div>
// //                     </div>
// //                   )}
// //                 </div>

// //                 {/* Audience error note — campaigns available but none selected */}
// //                 {showAudienceError && (
// //                   <p className="text-xs text-red-500 mt-1">
// //                     Please select a campaign to reuse audience
// //                   </p>
// //                 )}

// //                 {/* Descriptive note — turns red when no campaigns found on submit */}
// //                 {audienceType === "Reuse Audience" && !showAudienceError && (
// //                   <p
// //                     className={`text-xs mt-1 ${
// //                       showNoAudienceAvailableError ? "text-red-500" : "text-[#64748B]"
// //                     }`}
// //                   >
// //                     {getReuseAudienceNote()}
// //                   </p>
// //                 )}

// //                 {/* Full-width dropdown panel below */}
// //                 {audienceType === "Reuse Audience" && dropdownOpen && availableCampaigns.length > 0 && (
// //                   <div
// //                     ref={dropdownRef}
// //                     style={{
// //                       marginTop: "6px",
// //                       border: "0.5px solid #E2E8F0",
// //                       borderRadius: "8px",
// //                       overflow: "hidden",
// //                       maxHeight: "320px",
// //                       overflowY: "auto",
// //                       backgroundColor: "white",
// //                       boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
// //                     }}
// //                   >
// //                     {Object.entries(groupedCampaigns).map(([workspaceName, campaigns]) => (
// //                       <React.Fragment key={workspaceName}>
// //                         {/* Workspace Header */}
// //                         <div
// //                           style={{
// //                             padding: "6px 12px",
// //                             backgroundColor: "#F8FAFC",
// //                             borderBottom: "0.5px solid #E2E8F0",
// //                             fontSize: "11px",
// //                             fontWeight: 500,
// //                             color: "#64748B",
// //                             textTransform: "uppercase",
// //                             letterSpacing: "0.4px",
// //                           }}
// //                         >
// //                           {workspaceName}
// //                         </div>

// //                         {/* Campaign Rows */}
// //                         {campaigns.map((campaign, idx) => {
// //                           const channelBadges = getChannelBadges(campaign.total_traveller_count);
// //                           const isSelected = String(campaign.campaign_id) === selectedCampaign;
// //                           return (
// //                             <div
// //                               key={campaign.campaign_id}
// //                               onClick={() => {
// //                                 setSelectedCampaign(String(campaign.campaign_id));
// //                                 setDropdownOpen(false);
// //                               }}
// //                               style={{
// //                                 padding: "10px 14px",
// //                                 borderBottom:
// //                                   idx < campaigns.length - 1
// //                                     ? "0.5px solid #F1F5F9"
// //                                     : "none",
// //                                 cursor: "pointer",
// //                                 backgroundColor: isSelected ? "#F0F7FF" : "white",
// //                               }}
// //                               onMouseEnter={(e) =>
// //                                 ((e.currentTarget as HTMLDivElement).style.backgroundColor = "#F8FAFC")
// //                               }
// //                               onMouseLeave={(e) =>
// //                                 ((e.currentTarget as HTMLDivElement).style.backgroundColor =
// //                                   isSelected ? "#F0F7FF" : "white")
// //                               }
// //                             >
// //                               {/* Name + Badges */}
// //                               <div
// //                                 style={{
// //                                   display: "flex",
// //                                   alignItems: "center",
// //                                   gap: "6px",
// //                                   flexWrap: "wrap",
// //                                   marginBottom: "4px",
// //                                 }}
// //                               >
// //                                 <span
// //                                   style={{
// //                                     fontSize: "13px",
// //                                     fontWeight: 500,
// //                                     color: "#020617",
// //                                   }}
// //                                 >
// //                                   {campaign.campaign_name}
// //                                 </span>
// //                                 <span
// //                                   style={{
// //                                     ...badgeBase,
// //                                     ...getStatusBadgeStyle(campaign.status),
// //                                   }}
// //                                 >
// //                                   {campaign.status.charAt(0).toUpperCase() +
// //                                     campaign.status.slice(1)}
// //                                 </span>
// //                                 {channelBadges.map((badge) => (
// //                                   <span key={badge} style={channelBadgeStyle}>
// //                                     {badge}
// //                                   </span>
// //                                 ))}
// //                               </div>

// //                               {/* Date Range + Delivered Count */}
// //                               <div
// //                                 style={{
// //                                   display: "flex",
// //                                   alignItems: "center",
// //                                   gap: "12px",
// //                                   fontSize: "12px",
// //                                   color: "#64748B",
// //                                 }}
// //                               >
// //                                 <span>{formatDateRange(campaign.start_date, campaign.end_date)}</span>
// //                                 <span style={{ color: "#94A3B8" }}>·</span>
// //                                 <span>
// //                                   <strong style={{ color: "#020617", fontWeight: 500 }}>
// //                                     {campaign.delivered_count.toLocaleString()}
// //                                   </strong>{" "}
// //                                   delivered
// //                                 </span>
// //                               </div>
// //                             </div>
// //                           );
// //                         })}
// //                       </React.Fragment>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>

// //               {/* ✅ Roaming Days Section */}
// //               <RoamingDaysSection isViewMode={isViewMode} />
// //             </AccordionContent>
// //           </AccordionItem>
// //         </Accordion>
// //       </div>
// //     </Card>
// //   );
// // };

// // export default AdvancedSettingsCard;

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { Card } from "../../../../Components/ui/card";
// import { Label } from "../../../../Components/ui/label";
// import { Switch } from "../../../../Components/ui/switch";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from "../../../../Components/ui/select";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionTrigger,
//   AccordionContent,
// } from "../../../../Components/ui/accordion";
// import { useCampaignContext } from "../CampaignContext";
// import RoamingDaysSection from "./RoamingDaysSection";
// import { useSelector } from "react-redux";
// import { RootState } from "@/src/State/store";
// import { getChannelCounts } from "../utils/getChannelCounts";

// interface Campaign {
//   campaign_id: number;
//   campaign_name: string;
//   advertiser_workspace_id: number;
//   workspace_name: string;
//   status: string;
//   start_date: string;
//   end_date: string;
//   total_traveller_count: string;
//   delivered_count: number;
// }

// const getStatusBadgeStyle = (status: string): React.CSSProperties => {
//   switch (status.toLowerCase()) {
//     case "active":
//       return { backgroundColor: "#EAF3DE", color: "#3B6D11" };
//     case "paused":
//       return { backgroundColor: "#FAEEDA", color: "#854F0B" };
//     case "completed":
//       return { backgroundColor: "#F1EFE8", color: "#444441" };
//     default:
//       return { backgroundColor: "#F1EFE8", color: "#444441" };
//   }
// };

// const getChannelBadges = (totalTravellerCount: string): string[] => {
//   try {
//     const parsed = JSON.parse(totalTravellerCount);
//     const badges: string[] = [];
//     if (parsed.sms_count?.length > 0) badges.push("SMS");
//     if (parsed.whatsapp_count?.length > 0) badges.push("WhatsApp");
//     return badges;
//   } catch {
//     return [];
//   }
// };

// const formatDateRange = (startDate: string, endDate: string): string => {
//   const format = (d: string) =>
//     new Date(d).toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//   return `${format(startDate)} – ${format(endDate)}`;
// };

// const badgeBase: React.CSSProperties = {
//   fontSize: "11px",
//   padding: "2px 8px",
//   borderRadius: "99px",
//   fontWeight: 500,
//   display: "inline-block",
//   whiteSpace: "nowrap",
// };

// const channelBadgeStyle: React.CSSProperties = {
//   ...badgeBase,
//   backgroundColor: "#EEEDFE",
//   color: "#3C3489",
// };

// const AdvancedSettingsCard: React.FC = () => {
//   const {
//     allocationType,
//     setAllocationType,
//     isDuplicatePrevented,
//     setIsDuplicatePrevented,
//     isPremiumOnly,
//     setIsPremiumOnly,
//     audienceType,
//     setAudienceType,
//     selectedCampaign,
//     setSelectedCampaign,
//     isViewMode,
//     selectedChannels,
//     countries,
//     whatsappData,
//     smsData,
//     fromCountryISOs,
//     selectedToCountryISO,
//     isSubmitAttempted,
//   } = useCampaignContext();

//   const accountId = useSelector((state: RootState) => state.authentication.account_id);
//   const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
//   const selectedFromCountryISOs = useSelector(
//     (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
//   );

//   const [availableCampaigns, setAvailableCampaigns] = useState<Campaign[]>([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   // Stable string key — only changes when actual traveller count values change
//   const travellerCountKey = JSON.stringify(
//     getChannelCounts(whatsappData, smsData, selectedToCountryISO, fromCountryISOs)
//   );

//   // Close dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
//         setDropdownOpen(false);
//         setSearchTerm("");
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const fromCountryNames = selectedFromCountryISOs
//     .map((iso: string) => {
//       const match = countries.find(
//         (c) => c.country_iso.toLowerCase() === iso.toLowerCase()
//       );
//       return match ? match.country_name : iso.toUpperCase();
//     })
//     .join(", ");

//   const channelLabel = selectedChannels.join(" & ");

//   const GetCampaignsByAccountId = async () => {
//     try {
//       const travellerCount = getChannelCounts(
//         whatsappData,
//         smsData,
//         selectedToCountryISO,
//         fromCountryISOs
//       );

//       const res = await axios.post(`${apiUrlAdvAcc}/GetCampaignNamesByAccountId`, {
//         userAccountId: accountId,
//         channels: selectedChannels.join(","),
//         fromCountryISOs: selectedFromCountryISOs.join(","),
//         travellerCount,
//       });

//       if (res.data.status === "Success" && Array.isArray(res.data.campaignList)) {
//         setAvailableCampaigns(res.data.campaignList);
//       } else {
//         setAvailableCampaigns([]);
//       }
//     } catch (err) {
//       setAvailableCampaigns([]);
//     }
//   };

//   useEffect(() => {
//     if (
//       audienceType === "Reuse Audience" &&
//       selectedChannels.length > 0 &&
//       selectedFromCountryISOs.length > 0
//     ) {
//       GetCampaignsByAccountId();
//     }
//   }, [audienceType, selectedChannels, selectedFromCountryISOs, travellerCountKey]);

//   // Filter campaigns by search term
//   const filteredCampaigns = availableCampaigns.filter((c) =>
//     c.campaign_name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const groupedCampaigns = filteredCampaigns.reduce((acc, campaign) => {
//     if (!acc[campaign.workspace_name]) {
//       acc[campaign.workspace_name] = [];
//     }
//     acc[campaign.workspace_name].push(campaign);
//     return acc;
//   }, {} as Record<string, Campaign[]>);

//   const selectedCampaignName = availableCampaigns.find(
//     (c) => String(c.campaign_id) === selectedCampaign
//   )?.campaign_name;

//   const getReuseAudienceNote = () => {
//     if (selectedChannels.length === 0 || selectedFromCountryISOs.length === 0) {
//       return "Select channel and from-country to see matching campaigns";
//     }
//     if (availableCampaigns.length > 0) {
//       return `Showing ${channelLabel} campaigns from ${fromCountryNames} only. Channel and from-country must match.`;
//     }
//     return `No ${channelLabel} campaigns from ${fromCountryNames} found. Run a ${channelLabel} campaign from this country first to enable audience reuse.`;
//   };

//   // Red border + error note when submit attempted, campaigns available but none selected
//   const showAudienceError =
//     isSubmitAttempted &&
//     audienceType === "Reuse Audience" &&
//     availableCampaigns.length > 0 &&
//     !selectedCampaign;

//   // Turns descriptive note red when submit attempted but no campaigns found
//   const showNoAudienceAvailableError =
//     isSubmitAttempted &&
//     audienceType === "Reuse Audience" &&
//     availableCampaigns.length === 0 &&
//     selectedChannels.length > 0 &&
//     selectedFromCountryISOs.length > 0;

//   return (
//     <Card className="w-[600px] mt-4 mb-20 p-4 shadow-sm">
//       <div className="text-left">
//         <Accordion type="single" collapsible className="w-full">
//           <AccordionItem value="advanced-settings" className="border-b-0">
//             <AccordionTrigger className="text-base font-bold text-[#020617]">
//               Advanced Settings
//             </AccordionTrigger>
//             <AccordionContent>
//               {/* Premium Contacts Only */}
//               <div className="flex items-center space-x-2 mt-1">
//                 <Switch
//                   id="premiumContactsOnly"
//                   checked={isPremiumOnly}
//                   onCheckedChange={setIsPremiumOnly}
//                   disabled={isViewMode}
//                 />
//                 <Label
//                   htmlFor="premiumContactsOnly"
//                   className="font-medium text-[#020617]"
//                   style={{ fontSize: "14px" }}
//                 >
//                   Premium Contacts Only
//                 </Label>
//               </div>

//               {/* Prevent Duplicate Messages */}
//               <div className="flex items-center space-x-2 mt-4">
//                 <Switch
//                   id="preventDuplicateMessages"
//                   checked={isDuplicatePrevented}
//                   onCheckedChange={setIsDuplicatePrevented}
//                   disabled={isViewMode}
//                 />
//                 <Label
//                   htmlFor="preventDuplicateMessages"
//                   className="font-medium text-[#020617]"
//                   style={{ fontSize: "14px" }}
//                 >
//                   Prevent duplicate Messages
//                 </Label>
//               </div>

//               {/* Allocation Type */}
//               <div className="mt-4">
//                 <Label
//                   htmlFor="allocationType"
//                   className="font-medium text-[#020617]"
//                   style={{ fontSize: "14px" }}
//                 >
//                   Allocation Type
//                 </Label>
//                 <Select
//                   value={allocationType}
//                   onValueChange={setAllocationType}
//                   disabled={isViewMode}
//                 >
//                   <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
//                     <SelectValue placeholder="Select Allocation Type" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="Daily Allocation">Daily Allocation</SelectItem>
//                     <SelectItem value="Lifetime Allocation">Lifetime Allocation</SelectItem>
//                   </SelectContent>
//                 </Select>
//                 <p className="text-xs text-[#64748B] mt-1">
//                   {allocationType === "Daily Allocation"
//                     ? "Distribute messages evenly across campaign duration"
//                     : "Send messages as soon as eligible travellers are available"}
//                 </p>
//               </div>

//               {/* Audience Type + Campaign Selection */}
//               <div className="mt-4">
//                 {/* Row: Audience Type + Campaign Trigger */}
//                 <div className="flex gap-4 items-end">
//                   {/* Audience Type Dropdown */}
//                   <div className="flex-1">
//                     <Label
//                       htmlFor="audienceType"
//                       className="font-medium text-[#020617]"
//                       style={{ fontSize: "14px" }}
//                     >
//                       Audience Type
//                     </Label>
//                     <Select
//                       value={audienceType}
//                       onValueChange={(value) => {
//                         setAudienceType(value);
//                         if (value !== "Reuse Audience") {
//                           setSelectedCampaign("");
//                           setDropdownOpen(false);
//                           setSearchTerm("");
//                         }
//                       }}
//                       disabled={isViewMode}
//                       defaultValue="None"
//                     >
//                       <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
//                         <SelectValue placeholder="Select Audience Type" />
//                       </SelectTrigger>
//                       <SelectContent>
//                         <SelectItem value="None">None</SelectItem>
//                         <SelectItem value="Reuse Audience">Reuse Audience</SelectItem>
//                         <SelectItem value="New Audience">New Audience</SelectItem>
//                       </SelectContent>
//                     </Select>

//                     {audienceType !== "Reuse Audience" && (
//                       <p className="text-xs text-[#64748B] mt-1">
//                         {audienceType === "None" || audienceType === ""
//                           ? "Use standard audience selection rules"
//                           : audienceType === "New Audience"
//                             ? "Target only Fresh Audience"
//                             : "Select how to target your audience"}
//                       </p>
//                     )}
//                   </div>

//                   {/* Campaign Trigger — shows only when Reuse Audience */}
//                   {audienceType === "Reuse Audience" && availableCampaigns.length > 0 && (
//                     <div className="flex-1">
//                       <div
//                         onClick={() => {
//                           if (!isViewMode) {
//                             setDropdownOpen((prev) => {
//                               if (prev) setSearchTerm("");
//                               return !prev;
//                             });
//                           }
//                         }}
//                         style={{
//                           border: showAudienceError
//                             ? "1.5px solid #EF4444"
//                             : dropdownOpen
//                               ? "1.5px solid #378ADD"
//                               : "1px solid #E2E8F0",
//                           borderRadius: "6px",
//                           padding: "8px 12px",
//                           fontSize: "13px",
//                           color: selectedCampaignName ? "#020617" : "#64748B",
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                           cursor: isViewMode ? "default" : "pointer",
//                           backgroundColor: "white",
//                           userSelect: "none",
//                           ...(isViewMode && { opacity: 0.5, pointerEvents: "none" }),
//                         }}
//                       >
//                         <span>{selectedCampaignName ?? "Select a campaign"}</span>
//                         <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//                           <path
//                             d={dropdownOpen ? "M3 7.5L6 4.5L9 7.5" : "M3 4.5L6 7.5L9 4.5"}
//                             stroke="#64748B"
//                             strokeWidth="1.2"
//                             strokeLinecap="round"
//                           />
//                         </svg>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 {/* Audience error note — campaigns available but none selected */}
//                 {showAudienceError && (
//                   <p className="text-xs text-red-500 mt-1">
//                     Please select a campaign to reuse audience
//                   </p>
//                 )}

//                 {/* Descriptive note — turns red when no campaigns found on submit */}
//                 {audienceType === "Reuse Audience" && !showAudienceError && (
//                   <p
//                     className={`text-xs mt-1 ${
//                       showNoAudienceAvailableError ? "text-red-500" : "text-[#64748B]"
//                     }`}
//                   >
//                     {getReuseAudienceNote()}
//                   </p>
//                 )}

//                 {/* Full-width dropdown panel below */}
//                 {audienceType === "Reuse Audience" && dropdownOpen && availableCampaigns.length > 0 && (
//                   <div
//                     ref={dropdownRef}
//                     style={{
//                       marginTop: "6px",
//                       border: "0.5px solid #E2E8F0",
//                       borderRadius: "8px",
//                       overflow: "hidden",
//                       maxHeight: "320px",
//                       overflowY: "auto",
//                       backgroundColor: "white",
//                       boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
//                     }}
//                   >
//                     {/* Search Input */}
//                     <div
//                       style={{
//                         padding: "8px 12px",
//                         borderBottom: "0.5px solid #E2E8F0",
//                         position: "sticky",
//                         top: 0,
//                         backgroundColor: "white",
//                         zIndex: 1,
//                       }}
//                     >
//                       <input
//                         type="text"
//                         placeholder="Search campaigns..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         onClick={(e) => e.stopPropagation()}
//                         style={{
//                           width: "100%",
//                           fontSize: "13px",
//                           border: "0.5px solid #E2E8F0",
//                           borderRadius: "4px",
//                           padding: "6px 10px",
//                           outline: "none",
//                           color: "#020617",
//                           boxSizing: "border-box",
//                         }}
//                       />
//                     </div>

//                     {/* No search results */}
//                     {filteredCampaigns.length === 0 && (
//                       <div
//                         style={{
//                           padding: "16px 14px",
//                           fontSize: "13px",
//                           color: "#64748B",
//                           textAlign: "center",
//                         }}
//                       >
//                         No campaigns match your search
//                       </div>
//                     )}

//                     {/* Campaign Groups */}
//                     {Object.entries(groupedCampaigns).map(([workspaceName, campaigns]) => (
//                       <React.Fragment key={workspaceName}>
//                         {/* Workspace Header */}
//                         <div
//                           style={{
//                             padding: "6px 12px",
//                             backgroundColor: "#F8FAFC",
//                             borderBottom: "0.5px solid #E2E8F0",
//                             fontSize: "11px",
//                             fontWeight: 500,
//                             color: "#64748B",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.4px",
//                           }}
//                         >
//                           {workspaceName}
//                         </div>

//                         {/* Campaign Rows */}
//                         {campaigns.map((campaign, idx) => {
//                           const channelBadges = getChannelBadges(campaign.total_traveller_count);
//                           const isSelected = String(campaign.campaign_id) === selectedCampaign;
//                           return (
//                             <div
//                               key={campaign.campaign_id}
//                               onClick={() => {
//                                 setSelectedCampaign(String(campaign.campaign_id));
//                                 setDropdownOpen(false);
//                                 setSearchTerm("");
//                               }}
//                               style={{
//                                 padding: "10px 14px",
//                                 borderBottom:
//                                   idx < campaigns.length - 1
//                                     ? "0.5px solid #F1F5F9"
//                                     : "none",
//                                 cursor: "pointer",
//                                 backgroundColor: isSelected ? "#F0F7FF" : "white",
//                               }}
//                               onMouseEnter={(e) =>
//                                 ((e.currentTarget as HTMLDivElement).style.backgroundColor = "#F8FAFC")
//                               }
//                               onMouseLeave={(e) =>
//                                 ((e.currentTarget as HTMLDivElement).style.backgroundColor =
//                                   isSelected ? "#F0F7FF" : "white")
//                               }
//                             >
//                               {/* Name + Badges */}
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "6px",
//                                   flexWrap: "wrap",
//                                   marginBottom: "4px",
//                                 }}
//                               >
//                                 <span
//                                   style={{
//                                     fontSize: "13px",
//                                     fontWeight: 500,
//                                     color: "#020617",
//                                   }}
//                                 >
//                                   {campaign.campaign_name}
//                                 </span>
//                                 <span
//                                   style={{
//                                     ...badgeBase,
//                                     ...getStatusBadgeStyle(campaign.status),
//                                   }}
//                                 >
//                                   {campaign.status.charAt(0).toUpperCase() +
//                                     campaign.status.slice(1)}
//                                 </span>
//                                 {channelBadges.map((badge) => (
//                                   <span key={badge} style={channelBadgeStyle}>
//                                     {badge}
//                                   </span>
//                                 ))}
//                               </div>

//                               {/* Date Range + Delivered Count */}
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "12px",
//                                   fontSize: "12px",
//                                   color: "#64748B",
//                                 }}
//                               >
//                                 <span>{formatDateRange(campaign.start_date, campaign.end_date)}</span>
//                                 <span style={{ color: "#94A3B8" }}>·</span>
//                                 <span>
//                                   <strong style={{ color: "#020617", fontWeight: 500 }}>
//                                     {campaign.delivered_count.toLocaleString()}
//                                   </strong>{" "}
//                                   delivered
//                                 </span>
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </React.Fragment>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* ✅ Roaming Days Section */}
//               <RoamingDaysSection isViewMode={isViewMode} />
//             </AccordionContent>
//           </AccordionItem>
//         </Accordion>
//       </div>
//     </Card>
//   );
// };

// export default AdvancedSettingsCard;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card } from "../../../../Components/ui/card";
import { Label } from "../../../../Components/ui/label";
import { Switch } from "../../../../Components/ui/switch";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../../../Components/ui/select";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../../../Components/ui/accordion";
import { useCampaignContext } from "../CampaignContext";
import RoamingDaysSection from "./RoamingDaysSection";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { getChannelCounts } from "../utils/getChannelCounts";

interface Campaign {
  campaign_id: number;
  campaign_name: string;
  advertiser_workspace_id: number;
  workspace_name: string;
  status: string;
  start_date: string;
  end_date: string;
  total_traveller_count: string;
  delivered_count: number;
}

const getStatusBadgeStyle = (status: string): React.CSSProperties => {
  switch (status.toLowerCase()) {
    case "active":
      return { backgroundColor: "#EAF3DE", color: "#3B6D11" };
    case "paused":
      return { backgroundColor: "#FAEEDA", color: "#854F0B" };
    case "completed":
      return { backgroundColor: "#F1EFE8", color: "#444441" };
    default:
      return { backgroundColor: "#F1EFE8", color: "#444441" };
  }
};

const getChannelBadges = (totalTravellerCount: string): string[] => {
  try {
    const parsed = JSON.parse(totalTravellerCount);
    const badges: string[] = [];
    if (parsed.sms_count?.length > 0) badges.push("SMS");
    if (parsed.whatsapp_count?.length > 0) badges.push("WhatsApp");
    return badges;
  } catch {
    return [];
  }
};

const formatDateRange = (startDate: string, endDate: string): string => {
  const format = (d: string) =>
    new Date(d).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  return `${format(startDate)} – ${format(endDate)}`;
};

const formatChannel = (channel: string): string => {
  if (channel.toLowerCase() === "sms") return "SMS";
  if (channel.toLowerCase() === "whatsapp") return "WhatsApp";
  return channel;
};

const badgeBase: React.CSSProperties = {
  fontSize: "11px",
  padding: "2px 8px",
  borderRadius: "99px",
  fontWeight: 500,
  display: "inline-block",
  whiteSpace: "nowrap",
};

const channelBadgeStyle: React.CSSProperties = {
  ...badgeBase,
  backgroundColor: "#EEEDFE",
  color: "#3C3489",
};

const AdvancedSettingsCard: React.FC = () => {
  const {
    allocationType,
    setAllocationType,
    isDuplicatePrevented,
    setIsDuplicatePrevented,
    isPremiumOnly,
    setIsPremiumOnly,
    audienceType,
    setAudienceType,
    selectedCampaign,
    setSelectedCampaign,
    isViewMode,
    selectedChannels,
    countries,
    targetCountries,
    whatsappData,
    smsData,
    fromCountryISOs,
    selectedToCountryISO,
    isSubmitAttempted,
    isTravellerCountExceeded,
    setIsTravellerCountExceeded,
  } = useCampaignContext();

  const accountId = useSelector((state: RootState) => state.authentication.account_id);
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const selectedFromCountryISOs = useSelector(
    (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
  );

  const [availableCampaigns, setAvailableCampaigns] = useState<Campaign[]>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Stable string key — only changes when actual traveller count values change
  const travellerCountKey = JSON.stringify(
    getChannelCounts(whatsappData, smsData, selectedToCountryISO, fromCountryISOs)
  );

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fromCountryNames = selectedFromCountryISOs
    .map((iso: string) => {
      const match = countries.find(
        (c) => c.country_iso.toLowerCase() === iso.toLowerCase()
      );
      return match ? match.country_name : iso.toUpperCase();
    })
    .join(", ");

  const toCountryName =
    targetCountries.find(
      (c) => c.country_iso.toLowerCase() === selectedToCountryISO?.toLowerCase()
    )?.country_name ??
    countries.find(
      (c) => c.country_iso.toLowerCase() === selectedToCountryISO?.toLowerCase()
    )?.country_name ??
    selectedToCountryISO?.toUpperCase() ??
    "";

  const channelLabel = selectedChannels.map(formatChannel).join(" & ");

  // Check if new campaign traveller count exceeds old campaign
  const checkTravellerCountWarning = (oldTravellerCountStr: string) => {
    try {
      const old = JSON.parse(oldTravellerCountStr);
      const newCount = getChannelCounts(
        whatsappData,
        smsData,
        selectedToCountryISO,
        fromCountryISOs
      );

      const hasExcess = (oldArr: any[], newArr: any[]) =>
        newArr.some((newEntry) => {
          const oldEntry = oldArr.find(
            (o) =>
              o.fromcountry === newEntry.fromcountry &&
              o.tocountry === newEntry.tocountry
          );
          return !oldEntry || newEntry.count > oldEntry.count;
        });

      const exceeds =
        hasExcess(old.sms_count || [], newCount.sms_count) ||
        hasExcess(old.whatsapp_count || [], newCount.whatsapp_count);

      setIsTravellerCountExceeded(exceeds);
    } catch {
      setIsTravellerCountExceeded(false);
    }
  };

  // Re-run check when traveller count changes and a campaign is already selected
  useEffect(() => {
    if (selectedCampaign && audienceType === "Reuse Audience") {
      const selected = availableCampaigns.find(
        (c) => String(c.campaign_id) === selectedCampaign
      );
      if (selected) {
        checkTravellerCountWarning(selected.total_traveller_count);
      }
    }
  }, [travellerCountKey, selectedCampaign]);

  const GetCampaignsByAccountId = async () => {
    try {
      const res = await axios.post(`${apiUrlAdvAcc}/GetCampaignNamesByAccountId`, {
        userAccountId: accountId,
        channels: selectedChannels.join(","),
        fromCountryISOs: selectedFromCountryISOs.join(","),
        toCountryISO: selectedToCountryISO,
      });

      if (res.data.status === "Success" && Array.isArray(res.data.campaignList)) {
        setAvailableCampaigns(res.data.campaignList);
      } else {
        setAvailableCampaigns([]);
      }
    } catch (err) {
      setAvailableCampaigns([]);
    }
  };

  useEffect(() => {
    if (
      audienceType === "Reuse Audience" &&
      selectedChannels.length > 0 &&
      selectedFromCountryISOs.length > 0 &&
      selectedToCountryISO
    ) {
      GetCampaignsByAccountId();
    }
  }, [audienceType, selectedChannels, selectedFromCountryISOs, selectedToCountryISO, travellerCountKey]);

  // Filter campaigns by search term
  const filteredCampaigns = availableCampaigns.filter((c) =>
    c.campaign_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const groupedCampaigns = filteredCampaigns.reduce((acc, campaign) => {
    if (!acc[campaign.workspace_name]) {
      acc[campaign.workspace_name] = [];
    }
    acc[campaign.workspace_name].push(campaign);
    return acc;
  }, {} as Record<string, Campaign[]>);

  const selectedCampaignName = availableCampaigns.find(
    (c) => String(c.campaign_id) === selectedCampaign
  )?.campaign_name;

  const getReuseAudienceNote = () => {
    if (
      selectedChannels.length === 0 ||
      selectedFromCountryISOs.length === 0 ||
      !selectedToCountryISO
    ) {
      return "Select channel, from-country and to-country to see matching campaigns";
    }
    if (availableCampaigns.length > 0) {
      return `Showing ${channelLabel} campaigns from ${fromCountryNames} to ${toCountryName} only.`;
    }
    return `No ${channelLabel} campaigns from ${fromCountryNames} to ${toCountryName} found.`;
  };

  // Red border + error note when submit attempted, campaigns available but none selected
  const showAudienceError =
    isSubmitAttempted &&
    audienceType === "Reuse Audience" &&
    availableCampaigns.length > 0 &&
    !selectedCampaign;

  // Turns descriptive note red when submit attempted but no campaigns found
  const showNoAudienceAvailableError =
    isSubmitAttempted &&
    audienceType === "Reuse Audience" &&
    availableCampaigns.length === 0 &&
    selectedChannels.length > 0 &&
    selectedFromCountryISOs.length > 0 &&
    !!selectedToCountryISO;

  return (
    <Card className="w-[600px] mt-4 mb-20 p-4 shadow-sm">
      <div className="text-left">
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="advanced-settings" className="border-b-0">
            <AccordionTrigger className="text-base font-bold text-[#020617]">
              Advanced Settings
            </AccordionTrigger>
            <AccordionContent>
              {/* Premium Contacts Only */}
              <div className="flex items-center space-x-2 mt-1">
                <Switch
                  id="premiumContactsOnly"
                  checked={isPremiumOnly}
                  onCheckedChange={setIsPremiumOnly}
                  disabled={isViewMode}
                />
                <Label
                  htmlFor="premiumContactsOnly"
                  className="font-medium text-[#020617]"
                  style={{ fontSize: "14px" }}
                >
                  Premium Contacts Only
                </Label>
              </div>

              {/* Prevent Duplicate Messages */}
              <div className="flex items-center space-x-2 mt-4">
                <Switch
                  id="preventDuplicateMessages"
                  checked={isDuplicatePrevented}
                  onCheckedChange={setIsDuplicatePrevented}
                  disabled={isViewMode}
                />
                <Label
                  htmlFor="preventDuplicateMessages"
                  className="font-medium text-[#020617]"
                  style={{ fontSize: "14px" }}
                >
                  Prevent duplicate Messages
                </Label>
              </div>

              {/* Allocation Type */}
              <div className="mt-4">
                <Label
                  htmlFor="allocationType"
                  className="font-medium text-[#020617]"
                  style={{ fontSize: "14px" }}
                >
                  Allocation Type
                </Label>
                <Select
                  value={allocationType}
                  onValueChange={setAllocationType}
                  disabled={isViewMode}
                >
                  <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
                    <SelectValue placeholder="Select Allocation Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Daily Allocation">Daily Allocation</SelectItem>
                    <SelectItem value="Lifetime Allocation">Lifetime Allocation</SelectItem>
                  </SelectContent>
                </Select>
                <p className="text-xs text-[#64748B] mt-1">
                  {allocationType === "Daily Allocation"
                    ? "Distribute messages evenly across campaign duration"
                    : "Send messages as soon as eligible travellers are available"}
                </p>
              </div>

              {/* Audience Type + Campaign Selection */}
              <div className="mt-4">
                {/* Row: Audience Type + Campaign Trigger */}
                <div className="flex gap-4 items-end">
                  {/* Audience Type Dropdown */}
                  <div className="flex-1">
                    <Label
                      htmlFor="audienceType"
                      className="font-medium text-[#020617]"
                      style={{ fontSize: "14px" }}
                    >
                      Audience Type
                    </Label>
                    <Select
                      value={audienceType}
                      onValueChange={(value) => {
                        setAudienceType(value);
                        if (value !== "Reuse Audience") {
                          setSelectedCampaign("");
                          setDropdownOpen(false);
                          setSearchTerm("");
                          setIsTravellerCountExceeded(false);
                        }
                      }}
                      disabled={isViewMode}
                      defaultValue="None"
                    >
                      <SelectTrigger className="mt-1 text-black placeholder:text-[#64748B] text-sm font-normal">
                        <SelectValue placeholder="Select Audience Type" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="None">None</SelectItem>
                        <SelectItem value="Reuse Audience">Reuse Audience</SelectItem>
                        <SelectItem value="New Audience">New Audience</SelectItem>
                      </SelectContent>
                    </Select>

                    {audienceType !== "Reuse Audience" && (
                      <p className="text-xs text-[#64748B] mt-1">
                        {audienceType === "None" || audienceType === ""
                          ? "Use standard audience selection rules"
                          : audienceType === "New Audience"
                            ? "Target only Fresh Audience"
                            : "Select how to target your audience"}
                      </p>
                    )}
                  </div>

                  {/* Campaign Trigger — shows only when Reuse Audience */}
                  {audienceType === "Reuse Audience" && availableCampaigns.length > 0 && (
                    <div className="flex-1">
                      <div
                        onClick={() => {
                          if (!isViewMode) {
                            setDropdownOpen((prev) => {
                              if (prev) setSearchTerm("");
                              return !prev;
                            });
                          }
                        }}
                        style={{
                          border: showAudienceError
                            ? "1.5px solid #EF4444"
                            : dropdownOpen
                              ? "1.5px solid #378ADD"
                              : "1px solid #E2E8F0",
                          borderRadius: "6px",
                          padding: "8px 12px",
                          fontSize: "13px",
                          color: selectedCampaignName ? "#020617" : "#64748B",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: isViewMode ? "default" : "pointer",
                          backgroundColor: "white",
                          userSelect: "none",
                          ...(isViewMode && { opacity: 0.5, pointerEvents: "none" }),
                        }}
                      >
                        <span>{selectedCampaignName ?? "Select a campaign"}</span>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path
                            d={dropdownOpen ? "M3 7.5L6 4.5L9 7.5" : "M3 4.5L6 7.5L9 4.5"}
                            stroke="#64748B"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>

                {/* Audience error note — campaigns available but none selected */}
                {showAudienceError && (
                  <p className="text-xs text-red-500 mt-1">
                    Please select a campaign to reuse audience
                  </p>
                )}

                {/* Traveller count exceeded error */}
                {isTravellerCountExceeded && audienceType === "Reuse Audience" && selectedCampaign && (
                  <p className="text-xs text-red-500 mt-1">
                    The traveller count for one or more countries exceeds the selected campaign's audience. Please review and adjust the counts before proceeding.
                  </p>
                )}

                {/* Descriptive note — turns red when no campaigns found on submit */}
                {audienceType === "Reuse Audience" && !showAudienceError && !isTravellerCountExceeded && (
                  <p
                    className={`text-xs mt-1 ${
                      showNoAudienceAvailableError ? "text-red-500" : "text-[#64748B]"
                    }`}
                  >
                    {getReuseAudienceNote()}
                  </p>
                )}

                {/* Full-width dropdown panel below */}
                {audienceType === "Reuse Audience" && dropdownOpen && availableCampaigns.length > 0 && (
                  <div
                    ref={dropdownRef}
                    style={{
                      marginTop: "6px",
                      border: "0.5px solid #E2E8F0",
                      borderRadius: "8px",
                      overflow: "hidden",
                      maxHeight: "320px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                    }}
                  >
                    {/* Search Input */}
                    <div
                      style={{
                        padding: "8px 12px",
                        borderBottom: "0.5px solid #E2E8F0",
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                        zIndex: 1,
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search campaigns..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          width: "100%",
                          fontSize: "13px",
                          border: "0.5px solid #E2E8F0",
                          borderRadius: "4px",
                          padding: "6px 10px",
                          outline: "none",
                          color: "#020617",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>

                    {/* No search results */}
                    {filteredCampaigns.length === 0 && (
                      <div
                        style={{
                          padding: "16px 14px",
                          fontSize: "13px",
                          color: "#64748B",
                          textAlign: "center",
                        }}
                      >
                        No campaigns match your search
                      </div>
                    )}

                    {/* Campaign Groups */}
                    {Object.entries(groupedCampaigns).map(([workspaceName, campaigns]) => (
                      <React.Fragment key={workspaceName}>
                        {/* Workspace Header */}
                        <div
                          style={{
                            padding: "6px 12px",
                            backgroundColor: "#F8FAFC",
                            borderBottom: "0.5px solid #E2E8F0",
                            fontSize: "11px",
                            fontWeight: 500,
                            color: "#64748B",
                            textTransform: "uppercase",
                            letterSpacing: "0.4px",
                          }}
                        >
                          {workspaceName}
                        </div>

                        {/* Campaign Rows */}
                        {campaigns.map((campaign, idx) => {
                          const channelBadges = getChannelBadges(campaign.total_traveller_count);
                          const isSelected = String(campaign.campaign_id) === selectedCampaign;
                          return (
                            <div
                              key={campaign.campaign_id}
                              onClick={() => {
                                setSelectedCampaign(String(campaign.campaign_id));
                                setDropdownOpen(false);
                                setSearchTerm("");
                                checkTravellerCountWarning(campaign.total_traveller_count);
                              }}
                              style={{
                                padding: "10px 14px",
                                borderBottom:
                                  idx < campaigns.length - 1
                                    ? "0.5px solid #F1F5F9"
                                    : "none",
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#F0F7FF" : "white",
                              }}
                              onMouseEnter={(e) =>
                                ((e.currentTarget as HTMLDivElement).style.backgroundColor = "#F8FAFC")
                              }
                              onMouseLeave={(e) =>
                                ((e.currentTarget as HTMLDivElement).style.backgroundColor =
                                  isSelected ? "#F0F7FF" : "white")
                              }
                            >
                              {/* Name + Badges */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  flexWrap: "wrap",
                                  marginBottom: "4px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#020617",
                                  }}
                                >
                                  {campaign.campaign_name}
                                </span>
                                <span
                                  style={{
                                    ...badgeBase,
                                    ...getStatusBadgeStyle(campaign.status),
                                  }}
                                >
                                  {campaign.status.charAt(0).toUpperCase() +
                                    campaign.status.slice(1)}
                                </span>
                                {channelBadges.map((badge) => (
                                  <span key={badge} style={channelBadgeStyle}>
                                    {badge}
                                  </span>
                                ))}
                              </div>

                              {/* Date Range + Delivered Count */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                  fontSize: "12px",
                                  color: "#64748B",
                                }}
                              >
                                <span>{formatDateRange(campaign.start_date, campaign.end_date)}</span>
                                <span style={{ color: "#94A3B8" }}>·</span>
                                <span>
                                  <strong style={{ color: "#020617", fontWeight: 500 }}>
                                    {campaign.delivered_count.toLocaleString()}
                                  </strong>{" "}
                                  delivered
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>

              {/* ✅ Roaming Days Section */}
              <RoamingDaysSection isViewMode={isViewMode} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </Card>
  );
};

export default AdvancedSettingsCard;